module.exports = __webpack_public_path__ + "img/example-education-zones.fa567ee1.webp";